import * as T from './loyaltyToastTypes';
import type { Toast } from './loyaltyToastTypes';

export const addToast = (toast: Toast) => ({
  type: T.ADD_TOAST as typeof T.ADD_TOAST,
  payload: toast,
});

export const removeToast = (id: string) => ({
  type: T.REMOVE_TOAST as typeof T.REMOVE_TOAST,
  payload: id,
});

export const removeToastAfterDelay = (id: string) => ({
  type: T.REMOVE_TOAST_AFTER_DELAY as typeof T.REMOVE_TOAST_AFTER_DELAY,
  payload: id,
});

export type LoyaltyToastAction =
  | ReturnType<typeof addToast>
  | ReturnType<typeof removeToast>
  | ReturnType<typeof removeToastAfterDelay>;
